import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {AutorizacaoLojaService} from "../services/autorizacao-loja.service";
import {NgxSmartBannerService} from "@netcreaties/ngx-smart-banner";
import {CookieService} from "ngx-cookie-service";
import {ConstantsService} from "../services/ConstantsService";
import {Platform} from '@angular/cdk/platform';
import {CarrinhoService} from "../services/carrinho.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'loja';
  exibindoBanner = false;
  possuiApp: boolean;
  empresa: any;
  constructor(private router: Router, private autorizacao: AutorizacaoLojaService,
              private readonly ngxSmartBannerService: NgxSmartBannerService,
              private readonly viewContainerRef: ViewContainerRef, private activatedRoute: ActivatedRoute,
              private readonly cookieService: CookieService,
              private readonly constantsService: ConstantsService,  private carrinhoService: CarrinhoService,
              private readonly platform: Platform) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd && (<any>window).ga ) {
        (<any>window).ga('set', 'page', event.urlAfterRedirects);
        (<any>window).ga('send', 'pageview');

        if((<any>window).analytics) {
          (<any>window).ga('custom.set', 'page', event.urlAfterRedirects);
          (<any>window).ga('custom.send', 'pageview');
        }

        if((<any>window).dataLayer) {
          (<any>window).dataLayer.push({event: 'pageview'});
        }
      }
    });

    let deferredPrompt;

    this.carregueEmpresaExibaBanner();
    window.addEventListener('beforeinstallprompt', (e) => {
      // Prevent Chrome 67 and earlier from automatically showing the prompt
      this.carregueEmpresaExibaBanner();
      //e.preventDefault();
      // Stash the event so it can be triggered later.
      deferredPrompt = e;
    });
  }

  carregueEmpresaExibaBanner() {
    this.constantsService.empresa$.subscribe( (empresa) => {
      if( !empresa )    return;

      this.ajusteVariaveisTema(empresa);

      if( empresa.tema === 'quiosque' ) {
        return;
      }

      this.empresa = empresa;
      window['tema'] = empresa.tema;

      this.constantsService.moduloApp$.subscribe(possuiApp => {
        this.possuiApp = possuiApp;

        if (this.possuiApp) {
          this.exibaBanner();
        }
      });
    });
  }

  exibaBanner() {
    if( !this.empresa.appIos && this.platform.IOS ) { //não tem app para ios
      return;
    }

    if( window['Flutter'] || window['flutter_inappwebview'] ) { //dentro do app não deve exibir o banner
      return;
    }

    // Não exibir o banner se estiver na tela de tablet-pedidos
    if (this.router.url.includes('pedido-tablet')) {
      return;
    }

    this.cookieService.delete('smartbanner_closed');

    this.ngxSmartBannerService.onOpen.subscribe( () => {
      this.exibindoBanner = true;
    });
    this.ngxSmartBannerService.onClose.subscribe( () => {
      this.exibindoBanner = false;
    });
    const fotoLogo = `https://${this.empresa.dominio}.meucardapio.ai/images/empresa/` + this.empresa?.logo;

    this.ngxSmartBannerService.initialize({
      viewContainerRef: this.viewContainerRef,
      daysHidden: 0,
      daysReminder: 0,
      closeLabel: 'Fechar',
      author: this.empresa.nome,
      title: 'Baixe agora o app',
      price: 'Gratuito',
      priceSuffix: {
        ios: ' - na Play Store',
        android: ' - no Google Play'
      },
      icon: {
        ios: fotoLogo,
        android: fotoLogo
      },
      rating: {
        ios: 5,
        android: 5
      },
      buttonLabel: 'Download',
      buttonUrl: {
        android: 'https://play.google.com/store/apps/details?id=ai.meucardapio.' + this.empresa.dominio,
        ios: this.empresa.appIos
      }
    });
  }

  private extractHmFromUrl(url: string): string | null {
    const matches = url.match(/\/local\/([a-zA-Z0-9]+)/);
    return matches ? matches[1] : null;
  }

  private extraiaTokenCartaoDaUrl(url: string): string | null {
    const matches = url.match(/\/comanda\/([^/?#]+)/);
    return matches ? matches[1] : null;
  }

  ngOnInit(): void {

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if(!this.constantsService.carregou){
          const hm = this.extractHmFromUrl(event.urlAfterRedirects);
          const tokenCartao = this.extraiaTokenCartaoDaUrl(event.urlAfterRedirects);

          this.inicializePedido(hm, tokenCartao).then( (pedido: any) => {
            const deMesa = hm != null || (pedido && pedido.estaEmFluxoMesa());

            this.constantsService.recarregueEmpresa( deMesa)
          });

        }
      }
    });

    if( this.estahNoApp() ) {
      this.autorizacao.estaLogado().then( (resposta: any) => {
        if(resposta.logado) {
          const usuario = this.autorizacao.getUsuario();

          const mensagem = {
            tipo: 'usuario',
            usuario: usuario
          }

          this.notifiqueAppFlutter(mensagem);
        } else {
          const mensagem = {
            tipo: 'carregou'
          }
        }
      })
    }
  }

  private async inicializePedido(hashMesa: string, tokenCartao: string = null) {
    if(tokenCartao) {
      try {
        if(window['multipedido']) {
          const pedido = this.carrinhoService.obtenhaPedido();
          delete pedido.tokenCartaoPendente;
          delete pedido.codigoCartaoPendente;
          this.carrinhoService.salvePedido(pedido);
          throw 'Comanda não disponível para pedidos em múltiplas lojas.';
        }

        const cartao = await this.carrinhoService.obtenhaCartaoClientePeloToken(tokenCartao);
        return this.carrinhoService.iniciePedidoComCartao(tokenCartao, cartao.codigo);
      } catch (erro) {
        window.alert(erro || 'Comanda inválida.');
        return this.carrinhoService.obtenhaPedido();
      } finally {
        this.removaTokenCartaoDaUrl();
      }
    }

    if(hashMesa) {
      const mesa: any = await this.carrinhoService.obtenhaMesa(hashMesa);
      if(!mesa)
        return this.carrinhoService.obtenhaPedido({ expirada: true });

      mesa.hash = hashMesa;
      return this.carrinhoService.obtenhaPedido(mesa);
    }

    return this.carrinhoService.obtenhaPedido();
  }

  private removaTokenCartaoDaUrl() {
    const caminho = window.location.pathname.replace(/\/comanda\/[^/]+\/?$/, '') || '/';
    window.history.replaceState(window.history.state, '', caminho + window.location.search + window.location.hash);
  }

  estahNoApp() {
    return window['Flutter'] || window['flutter_inappwebview'];
  }

  notifiqueAppFlutter(mensagem: any) {
    if( window['Flutter'] ) {
      window['Flutter'].postMessage(JSON.stringify(mensagem));
    }

    if( window['flutter_inappwebview'] ) {
      window['flutter_inappwebview'].logou(mensagem);
    }
  }

  ajusteVariaveisTema(empresa: any) {
      if( empresa.temaPersonalizado ) {
        const t = empresa.temaPersonalizado;
        document.documentElement.style.setProperty('--cor-fundo', t.corFundo || '#f7f8f8');
        document.documentElement.style.setProperty('--cor-texto', t.corTextoSecundaria || 'inherit');
        document.documentElement.style.setProperty('--cor-texto-topo', t.corTextoTopo || t.corTextoPrimaria || '#212529');
        document.documentElement.style.setProperty('--cor-texto-primaria', t.corTextoPrimaria || 'inherit');
        document.documentElement.style.setProperty('--cor-texto-secundaria', t.corTextoSecundaria || 'inherit');
        document.documentElement.style.setProperty('--cor-texto-muted', t.corTexto ? `color-mix(in srgb, ${t.corTexto} 70%, black)` : '#6c757d');
        document.documentElement.style.setProperty('--cor-botao', t.corBotao || '#007bff');
        document.documentElement.style.setProperty('--cor-texto-botao', t.corTextoBotao || '#FFFFFF');
        document.documentElement.style.setProperty('--cor-preco-adicional', t.corPrecoAdicional || '#7e57c2');
        document.documentElement.style.setProperty('--cor-texto-preco-adicional', t.corTextoPrecoAdicional || '#FFFFFF');
        document.documentElement.style.setProperty('--cor-fundo-site', t.corFundoDoSite || '#f7f8f8');
        document.documentElement.style.setProperty('--cor-fundo-elementos', t.corFundoElementos || '#ffffff');
        document.documentElement.style.setProperty('--cor-borda', t.corBorda || '#e2e3e3');
        document.documentElement.style.setProperty('--cor-destaque', t.corDestaque || '#e2e3e3');
        document.documentElement.style.setProperty('--cor-hover', t.corHover || '#e2e3e3');
        document.documentElement.style.setProperty('--cor-preco', t.corPreco || '#e2e3e3');
        document.documentElement.style.setProperty('--cor-radio', t.corBotao || '#007bff');
        document.documentElement.style.setProperty('--cor-texto-rodape', t.corTextoRodape || t.corTextoFundo || 'white');
        document.documentElement.style.setProperty('--cor-fundo-rodape', t.corFundoRodape || t.corFundo || '#222');
        document.documentElement.style.setProperty('--cor-borda-rodape', t.corBordaRodape || t.corBorda || '#dee2e6');
        document.documentElement.style.setProperty('--cor-item-ativo-rodape', t.corItemAtivoRodape || t.corBotao || '#007bff');
        document.documentElement.style.setProperty('--cor-botao-mais-menos-rodape', t.corBotaoMaisMenosRodape || '#787878');
        document.documentElement.style.setProperty('--cor-botao-rodape', t.corBotaoFooter || t.corBotao || '#007bff');
        document.documentElement.style.setProperty('--cor-fundo-carrinho', t.corFundoCarrinho || t.corBotaoFooter || t.corBotao || '#3E9920');
        document.documentElement.style.setProperty('--cor-texto-carrinho', t.corTextoCarrinho || t.corTextoBotao || '#FFFFFF');
      }
  }

}
